import React from 'react'
import styles from './MicrositeLoadStrategyBadge.module.css'

/**
 * MicrositeLoadStrategyBadge
 * Script loading strategy: SYNC / ASYNC / DEFER.
 *
 * Usage:
 *   <MicrositeLoadStrategyBadge value={row.loadStrategy} />
 */
const TONE_MAP = {
    SYNC: 'amber',
    ASYNC: 'blue',
    DEFER: 'neutral'
}

const MicrositeLoadStrategyBadge = ({ value }) => (
    <span className={`${styles.badge} ${styles[`tone_${TONE_MAP[value] || 'neutral'}`]}`}>
        {value}
    </span>
)

export default MicrositeLoadStrategyBadge